import { render, staticRenderFns } from "./tinfoLinkC.vue?vue&type=template&id=4767f201&"
import script from "./tinfoLinkC.vue?vue&type=script&lang=js&"
export * from "./tinfoLinkC.vue?vue&type=script&lang=js&"
import style0 from "./tinfoLinkC.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports